import * as NDocumentPicker from 'expo-document-picker';
export const DocumentPicker = NDocumentPicker;